var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "job-fuzzy-matrix--row" },
    _vm._l(_vm.valueGroups, function(item) {
      return _c("ValueGroup", {
        key: _vm.row.id + "-" + item.category.id,
        attrs: { category: item.category, row: _vm.row, values: item.values },
        on: {
          filterValue: function($event) {
            return _vm.$emit("filterValue", $event)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }